import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { deleteLostTicketFailed, deleteLostTicketSuccessful } from '../actions';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* deleteLostTicket(action) {
  try {
    const id = action.payload;

    const url = `${BACKEND_URL}/proxy/tariff/v1/lost-tickets/${id}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteLostTicketSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(deleteLostTicketFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(deleteLostTicketFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
